import Constants from '../utils/consts';
import SqlString from 'sqlstring';
var http = require('follow-redirects').https;
var qs = require('querystring');

export default async function deleteSectionService(username, token, appId, section) {
    return new Promise(function (resolve, reject) {
        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apiMyBeB/deleteSection.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            resolve();
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        // alert(JSON.stringify(content))

        var postData = qs.stringify({
            'uname': username,
            'token': token,
            'appId': appId,
            'section': section,
        });

        console.log(postData);
        req.write(postData);

        req.end();

        
    });
}
